<template>
  <div class="page-wrapper">
    <header-mobile/>
    <sidebar/>

    <div class="page-container">
      <header-desktop/>
      <div class="main-content">
        <div class="section__content section__content--p30">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMobile from "@/components/app/HeaderMobile.vue";
import Sidebar from "@/components/app/Sidebar.vue";
import HeaderDesktop from "@/components/app/HeaderDesktop.vue";

export default {
  components: {
    HeaderMobile,
    Sidebar,
    HeaderDesktop
  }
};
</script>
